module.exports = __webpack_public_path__ + "img/student-default-girl.723e1baa.png";